import React from 'react';
import { CONTACT, NextCta } from '../Layout';
import { FadeLink, Section, useCopy, useParallax } from '../core';
import aboutHero from '../assets/img/about-hero.webp';
import portraitJinhu from '../assets/img/portrait-jinhu.webp';
import portraitQiudan from '../assets/img/portrait-qiudan.webp';

const copy = {
  en: {
    title: <>Connecting research,<br /><span className="g">products and</span> real needs.</>,
    lede: 'AgentecFusion develops AI agent products for everyday work and higher education. Agentec One is a local desktop workspace for conversations, tasks, memory, skills, tools and model services. Learn, previously documented as AgentecCampus, is a role-based workspace for university learning, teaching and research. Availability, integrations and use cases depend on the product environment and configuration.',
    approach: 'OUR APPROACH', approachTitle: <>Ideas with an<br />application in mind.</>,
    approachText: 'From defining a need and designing a product to integrating a system, we bring research, engineering and product work together around the use case, data boundaries and user experience.',
    discover: 'Discover our products',
    teamChip: 'MEET THE TEAM', teamTitle: 'Start a conversation with our team.',
    teamText: 'Reach the right person directly — for technical and research questions, or for business partnerships and investment.',
    email: 'Email',
    people: [
      { name: 'Jinhu Qi', role: 'AI RESEARCH LEAD', focus: 'Technical enquiries & research collaboration', alt: 'Portrait of Jinhu Qi', email: CONTACT.research, image: portraitJinhu },
      { name: 'Qiudan Wang', role: 'BUSINESS MANAGER', focus: 'Business partnerships & investment', alt: 'Portrait of Qiudan Wang', email: CONTACT.business, image: portraitQiudan }
    ]
  },
  zh: {
    title: <>连接研究、<br /><span className="g">产品与</span>真实需求。</>,
    lede: 'AgentecFusion 专注于面向真实工作场景的可信智能体产品。Agentec One 是本地桌面个人智能体工作台，整合对话、任务、记忆、技能、工具和模型服务；Learn（原产品资料称 AgentecCampus）面向高校师生与研究团队，按角色组织课程材料、学习路径、教学支持和研究证据，并为关键决定保留人工审核。具体部署与服务范围以产品环境、权限和配置为准。',
    approach: '我们的方法', approachTitle: <>想法，<br />始终面向应用。</>,
    approachText: '从定义需求、设计产品到集成系统，我们围绕使用场景、数据边界与用户体验，把研究、工程与产品工作结合在一起。',
    discover: '了解我们的产品',
    teamChip: '认识团队', teamTitle: '与我们的团队开启对话。',
    teamText: '直接联系合适的负责人——技术与研究问题，或商务合作与投资。',
    email: '邮件',
    people: [
      { name: '齐金虎 Jinhu Qi', role: 'AI 研究负责人', focus: '技术咨询与科研合作', alt: '齐金虎（Jinhu Qi）肖像', email: CONTACT.research, image: portraitJinhu },
      { name: 'Qiudan Wang', role: '商务经理', focus: '商务合作与投资', alt: 'Qiudan Wang 肖像', email: CONTACT.business, image: portraitQiudan }
    ]
  }
};

export default function AboutPage() {
  const { t } = useCopy(copy);
  useParallax();
  return <>
    <section className="ahero" aria-labelledby="h1">
      <div className="bg" aria-hidden="true" data-px=".04"><img src={aboutHero} alt="" /></div>
      <div className="wrap hin">
        <h1 id="h1" style={{ '--i': 0 }}>{t.title}</h1>
        <p className="lede" style={{ '--i': 2 }}>{t.lede}</p>
      </div>
    </section>
    <Section className="appr" id="approach">
      <div className="wrap">
        <div data-reveal="" style={{ '--i': 0 }}><p className="k mono-k">{t.approach}</p><h2>{t.approachTitle}</h2></div>
        <div data-reveal="" style={{ '--i': 1 }}><p>{t.approachText}</p>
          <FadeLink className="btn btn-dark" to="/products">{t.discover} <span className="ar" aria-hidden="true">↗</span></FadeLink></div>
      </div>
    </Section>
    <Section className="team" id="team">
      <div className="wrap">
        <span className="tchip" data-reveal="" style={{ '--i': 0 }}><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 2.7 5.6 6.1.8-4.5 4.2 1.1 6-5.4-2.9-5.4 2.9 1.1-6L3.2 9.4l6.1-.8z" /></svg>{t.teamChip}</span>
        <h2 data-reveal="" style={{ '--i': 1 }}>{t.teamTitle}</h2>
        <p className="sub" data-reveal="" style={{ '--i': 2 }}>{t.teamText}</p>
        <div className="people">
          {t.people.map((person, index) => (
            <article key={person.email} className="person" style={{ '--i': index }}>
              <div className="por"><img src={person.image} alt={person.alt} loading="lazy" /><a className="mail" href={`mailto:${person.email}`}>{t.email} <span aria-hidden="true">↗</span></a></div>
              <h3>{person.name}</h3><p className="role mono-k">{person.role}</p><p>{person.focus}</p>
            </article>
          ))}
        </div>
      </div>
    </Section>
    <NextCta />
  </>;
}
